module.exports = __webpack_public_path__ + "static/img/jackie_chan.9e557ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/jackie_chan.jpg
// module id = 3r8j
// module chunks = 0